import {createStyles, Theme} from "@material-ui/core";
import {blueBackgroundColor, buttonOutlined, styleColors} from "src/main.style";

export const calendarStyle = (theme: Theme) => createStyles({
  container: {
    maxHeight: '100vh',
    height: '100vh',
    minHeight: '100vh',
    width:'100vw',
    maxWidth:'100vw',
    minWidth:'100vw',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: blueBackgroundColor,
  },
  buttonOutlined,
  popupPaper : {
    overflowX:'visible',
    overflowY:'visible',
  },
  popupBackground : {
    userSelect:'none',
    WebkitUserSelect:'none',
  },
  bigDialog : {
    margin: '90px auto auto auto',
    width: 'calc(100% - 16px)',
    position: 'relative',
  },
  '@keyframes backgroundFlash': backgroundFlash,
  flashDrawer : {
    animation: 'backgroundFlash 0.6s ease',
  },
});
const backgroundFlash = {
  '0%': {
    backgroundColor: styleColors.white,
  },
  '50%': {
    backgroundColor: styleColors.paleCoral,
  },
  '100%': {
    backgroundColor: styleColors.white,
  },
};


// WEBPACK FOOTER //
// ./src/containers/calendar/calendar.style.ts